import {
    FilterProps,
    FilterValues,
    KmsTypeFilterBase,
    KmsTypeFilterDependency,
    KmsTypeFilterItemBase,
} from "@kaltura/mediaspace-shared-types";

/**
 * filter/item dependency
 */
const isDisabled = (
    filterValues: FilterValues,
    { param = "", whiteList, blackList }: KmsTypeFilterDependency
): boolean => {
    // whitelist dependency
    if (
        whiteList
        && whiteList.length
        && !whiteList.some((value) => {
            if (Array.isArray(filterValues[param])) {
                // `filterValues[param]` is array:
                return !!filterValues[param]?.includes(value);
            }
            // `filterValues[param]` is a string, and it is the same as `value`
            else return filterValues[param] === value;
        })
    ) {
        // not in whitelist
        return true;
    }

    // blacklist dependency
    if (
        blackList
        && blackList.length
        && blackList.some((value) => {
            if (Array.isArray(filterValues[param])) {
                // `filterValues[param]` is array:
                return !!filterValues[param]?.includes(value);
            }
            // `filterValues[param]` is a string, and it is the same as `value`
            else return filterValues[param] === value;
        })
    ) {
        // in blacklist
        return true;
    }

    // just param, no whitelist, no blacklist
    if (param) {
        return !filterValues[param];
    }

    return false;
};

/**
 * calculate filters and filter items dependency
 */
export const getDisabledFilters = <T extends KmsTypeFilterBase<KmsTypeFilterItemBase<any>>>(
    filterValues: FilterValues,
    filters: FilterProps<T>[]
): FilterProps<T>[] => {
    return filters.map((filter) => {
        // filter dependency
        const disabled = filter.disabled || (filter.depends && isDisabled(filterValues, filter.depends));

        // filter item dependency
        const items = filter.items.map((item) => {
            const disabled = item.disabled || (item.depends && isDisabled(filterValues, item.depends));

            return { ...item, disabled: disabled };
        });

        return { ...filter, disabled: disabled, items: items };
    });
};
